import React, { useCallback } from 'react';

import NiceModal, { useModal } from '@ebay/nice-modal-react';

import AssignParticipantDialog from 'components/dialogs/assignParticipantDialog/AssignParticipantDialog';

const Modal = NiceModal.create(({ ...props }: any) => {
  const modal = useModal();
  return (
    <AssignParticipantDialog
      open={modal.visible || props?.loading}
      onClose={modal.hide}
      onExited={modal.remove}
      {...props}
    />
  );
});

export const useAssignParticipantDialog = () => useCallback((props?: any) => NiceModal.show(Modal, { ...props }), []);
